import JSEncrypt from 'jsencrypt';
import { user_http } from "@/utils/http";

const encryptor = new JSEncrypt();
let hash, publicKey;

async function fetchPublicKey() {
    try {
        const response = await user_http.get("/user/key");
        publicKey = response.data.data.key;
        hash = response.data.data.hash;
        encryptor.setPublicKey(publicKey);
    } catch (error) {
        console.error("Failed to fetch public key:", error);
    }
}

export async function initializeEncryption() {
    await fetchPublicKey();
}

export function rsaEncrypt(data) {
    if (!publicKey || !hash) {
        console.error("Public key or hash is not set");
        return null;
    }
    return encryptor.encrypt(hash + data);
}
